import React from 'react';
import { types } from 'helpers';
import { Balances, FastOnboardBanner, Loading } from 'components';
import { useTypedSelector } from 'Store/_Store';
import { MetricFilter } from './Metrics';

const DashChart = React.lazy(() => import('./Chart'));
const DashTransactions = React.lazy(() => import('./Transactions'));
const DashMetrics = React.lazy(() => import('./Metrics'));

const Dashboard = () => {

    const { _auth: { business }, } = useTypedSelector((state) => state);

    const [currency, setCurrency] = React.useState<types.Currencies | null>(null);
    const [filter, setFilter] = React.useState<MetricFilter | null>(null);

    return (
        <React.Fragment>
            <React.Suspense fallback={<Loading spinning={true} />}>
                <FastOnboardBanner business={business} />
                <Balances onChange={(next) => { setCurrency(next); setFilter(null); }} />

                {currency && <DashMetrics currency={currency} onFilter={setFilter} />}

                <DashChart currency={currency || (business.wallets || [])[0]?.currency} />
                <DashTransactions currency={currency} filter={filter} onClearFilter={() => setFilter(null)} />
            </React.Suspense>
        </React.Fragment>
    );
}

export default Dashboard;